import { Field, ObjectType } from "./decorators";
import { IScrBaseResponse } from "../services/base.service";
import { StringOrPhoneNumber } from "./common.model";
import { User } from "./user.model";


@ObjectType()
export class Account {

    @Field({q:['summary','all']}) accountId?: number;
    @Field() fein?: string;
    @Field() duns?: string;
    @Field() companyUrl?: string;
    @Field() companySymbol?: string;
    @Field() monBillEnabled?: boolean;
    @Field() monBillAutoPayEnabled?: boolean;
    @Field() monBillPoNumber?: string;
    @Field() maxWfp?: number;
    @Field({q:['summary']}) unappliedCredits?: number;
    @Field() accountType?: string;
    @Field() accountStatus?: string;
    @Field() programTypeRequested?: string;
    @Field() programTypeReviewStatus?: string;
    @Field() programType?: string;
    @Field() governmentAgencyType?: string;
    @Field() governmentExplain?: string;
    @Field() governmentAgencyWebsite?: string;
    @Field() governmentAdditionalInfo?: string;

    @Field() charityAccreditation?: string;
    @Field() charityAdditionalInfo?: string;

    @Field({q:['summary','all']})firstName?: string;
    @Field({q:['summary','all']})lastName?: string;
    @Field() phone?: StringOrPhoneNumber;
    @Field() phoneExtension?: string;
    @Field({q:['summary','all']}) email?: string;

    @Field({q:['summary','all']}) company?: string;
    @Field() address1?: string;
    @Field() address2?: string;
    @Field() city?: string;
    @Field() state?: string;
    @Field() zip?: string;
    @Field() country?: string;

    @Field() secondaryFirstName?: string;
    @Field() secondaryLastName?: string;
    @Field() secondaryPhone?: StringOrPhoneNumber;
    @Field() secondaryPhoneExtension?: string;
    @Field() secondaryEmail?: string;

    @Field() billingFirstName?: string;
    @Field() billingLastName?: string;
    @Field() billingAddress1?: string;
    @Field() billingAddress2?: string;
    @Field() billingCity?: string;
    @Field() billingState?: string;
    @Field() billingZip?: string;
    @Field() billingCountry?: string;
    @Field() billingPhone?: StringOrPhoneNumber;
    @Field() billingPhoneExtension?: string;
    @Field() billingEmail?: string;
    misc?: string;
    @Field() nsCustomerInternalId?: string;

    createTime?: string; // ISO
    updateTime?: string; // ISO
    updatedBy?: string;
    
    @Field() registryComments?: string;
    @Field() internalComments?: string;

    monBillOrderStatus?: string;
    monthlyMode?: string;

    enabledUsers?: number; // only account search
    leasedCodes?: number;  // only account search
    defaultMaxWfp?: boolean;

    @Field() defaultApplicationProvider?: string;
    @Field() defaultAggregatorId?: number;

    accountBillingOnRenew?: boolean;
    monthlyInvoiceExists?: boolean;

    carrierWeeklyReportEmailList?: string[];

    @Field() linkedAccountEnabled?: boolean;
    @Field() linkedAccountList?: number[];
    @Field() managingAccountId?: number;
    @Field() linkedAccountName?: string;


    @Field() legalEntityType?: string; // not an enum.  use config.
    @Field() giin?: string;
    @Field() lei?: string;

    @Field() messagingRole?: string;
    @Field() estimatedAnnualRevenue?: number;
    @Field() smbAware?: boolean;
}


export class AccountSummary {
    account: Account = new Account();
    leasedCodeCount?: number;
    availableCredit?: number;
    managingAccountCompanyName?: string;
    monthlyBillingStatus?: string;
}

export class PasswordRequest {
    userName?: string;
    newPassword!: string;
    token!: string;
}

export class NewPasswordRequest {
    userid?: string;
    newPassword!: string;
    oldPassword!: string;
    accessToken!: string;

}


export interface AdminInfo {
    phone: string;
    email: string;
    name: string;
    country: string;
}
export interface AdminInfoResponse extends IScrBaseResponse {
  accountAdmins: AdminInfo[];
}

export interface AccountAndUser {
    account?: Account;
    user?: User;
}
export interface LinkedAccountListResponse extends IScrBaseResponse {
  accounts: AccountAndUser[];
}

export class Credit {
    @Field() public creditId!: number;
    @Field() public nsDocumentNumber!: string;
    @Field() public documentType!: string;
    @Field() public documentDate!: string;
    @Field() public startingAmount!: number;
    @Field() public amountRemaining!: number;
    @Field() public accountId!: number;
    @Field() public company!: string;
    @Field() public paymentMethod!: string;
    @Field() public memo!: string;
    @Field() public usableCredit?: boolean;
    @Field() public createTime!: string;
}

export enum CommentType {
    internalComments = 'internalComments',
    registryComments = 'registryComments'
}
